const RewardTypes = {
  MONETARY_REWARD: 'MonetaryReward',
  EXPERIENTIAL_REWARD: 'ExperientialReward',
};

export default RewardTypes;
